module.exports = __webpack_public_path__ + "static/media/fitness_icon.5b0dfa50.svg";